// extracted by mini-css-extract-plugin
export default {"statScreen":"styles_statScreen__JrwAR","glitch":"styles_glitch__5--pi","enterLink":"styles_enterLink__Ju52P","tooltip":"styles_tooltip__iPf97"};